import React, { FC } from "react";

// Interface
import { DRCalendarHeader } from "types/DRInterface";

const RepaymentCalendarHeader: FC<{ values: DRCalendarHeader }> = (props) => {
  return (
    <div className="calendar__table-header">
      {props.values.map((value: string) => {
        return (
          <div
            className="calendar__table-header-cell calendar__table-cell text text--secondary fw--600"
            key={value}
          >
            {value}
          </div>
        );
      })}
    </div>
  );
};

export default RepaymentCalendarHeader;
